// Helper per generare ed esportare file CSV lato client.
// I dati sono già caricati nelle pagine — generare il CSV qui evita
// roundtrip al backend e mantiene il filtro corrente applicato dall'utente.

// Quote un singolo valore secondo RFC 4180: stringa avvolta tra virgolette,
// virgolette interne raddoppiate. Gestisce null/undefined → stringa vuota.
function quote(value) {
  if (value === null || value === undefined) return "";
  let s = String(value);
  // Sostituisci eventuali line break interni con spazio per evitare di
  // rompere il CSV (Excel/Numbers gestiscono i \n quotati ma per
  // semplicità preferiamo line singole).
  s = s.replace(/\r?\n/g, " ").replace(/\s+/g, " ").trim();
  if (s.includes('"') || s.includes(",") || s.includes(";")) {
    s = '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

/**
 * Esporta `rows` come file CSV con headers `columns`.
 * @param {string} filename - nome del file (senza estensione)
 * @param {Array<{key:string,label:string}>} columns - mapping campo→label
 * @param {Array<Object>} rows - lista oggetti dato
 * @param {string} [separator=";"] - separatore (Excel italiano: `;`)
 */
export function exportCSV(filename, columns, rows, separator = ";") {
  const headerLine = columns.map((c) => quote(c.label)).join(separator);
  const dataLines = (rows || []).map((row) =>
    columns
      .map((c) => quote(typeof c.format === "function" ? c.format(row) : row[c.key]))
      .join(separator)
  );
  // BOM UTF-8 per garantire l'apertura corretta in Excel (caratteri accentati).
  const csv = "\ufeff" + [headerLine, ...dataLines].join("\r\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const ts = new Date().toISOString().slice(0, 10);
  a.download = `${filename}-${ts}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
